import AISearch from '../components/ai/AISearch';

export default function AISearchPage() {
    return <AISearch />;
}